import { ref, onMounted, onUnmounted } from 'vue'

const isOnline = ref(typeof navigator !== 'undefined' ? navigator.onLine : true)
const fetchFailed = ref(false)

function updateOnline() {
  isOnline.value = navigator.onLine
  if (navigator.onLine) fetchFailed.value = false
}

async function checkConnectivity() {
  if (!navigator.onLine) {
    isOnline.value = false
    return
  }
  try {
    await fetch('/api/healthz', { method: 'HEAD', cache: 'no-store' })
    fetchFailed.value = false
  } catch {
    fetchFailed.value = true
  }
}

let interval: ReturnType<typeof setInterval> | null = null

onMounted(() => {
  window.addEventListener('online', updateOnline)
  window.addEventListener('offline', updateOnline)
  interval = setInterval(checkConnectivity, 30000)
})

onUnmounted(() => {
  window.removeEventListener('online', updateOnline)
  window.removeEventListener('offline', updateOnline)
  if (interval) clearInterval(interval)
})

export function useOnlineStatus() {
  const offline = ref(false)

  function sync() {
    offline.value = !isOnline.value || fetchFailed.value
  }

  // Use a getter-like approach via computed would be cleaner,
  // but since refs are module-level singletons, we just expose them
  return { isOnline, fetchFailed, offline }
}
